const Typos = (() => {
	const { keywords, typoExceptions } = LIVE_SEARCH_DATA;
	const searchKeywords = Object.keys(keywords);

	const getLetters = (word1, word2) => [word1.split(""), word2.split("")];

	// Is there a single wrong letter?
	// apple -> appke
	const isTypoCondition1 = (word1, word2) => {
		if (word1.length !== word2.length) return false;
		const [letters1, letters2] = getLetters(word1, word2);

		const errorCount = letters1
			.map((letter, index) => letter !== letters2[index])
			.reduce((acc, curr) => (curr ? acc + 1 : acc));

		return errorCount === 1;
	};

	const swap = (passedLetters, first, second) => {
		// Make a copy
		const letters = [...passedLetters];
		const temp = letters[first];
		letters[first] = letters[second];
		letters[second] = temp;
		return letters;
	};

	// Are 2 letters swapped?
	// apple -> appel
	const isTypoCondition2 = (word1 = "", word2 = "") => {
		if (word1.length !== word2.length) return false;
		const [letters1, letters2] = getLetters(word1, word2);

		const isFlipped = letters1.slice(0, -1).some((v, i) => {
			const variation = swap(letters2, i, i + 1);
			return word1 === variation.join("");
		});
		return isFlipped;
	};

	// Percent of matching chars
	// apple -> applle
	const isTypoCondition3 = (word1 = "", word2 = "") => {
		if (word1.length === word2.length) return false;
		const [letters1, letters2] = getLetters(word1, word2);

		const longer = letters1.length > letters2.length ? letters1 : letters2;
		const shorter = letters1.length > letters2.length ? letters2 : letters1;
		const matchCount = longer.reduce(
			(acc, curr) => (curr == shorter[acc] ? acc + 1 : acc),
			0
		);

		const matchDiff = longer.length - matchCount;
		const matchRatio = matchDiff / longer.length;

		consell.log(`Match ratio: ${matchRatio.toString()}`);
		return matchRatio <= 0.3;
	};

	// Public
	const isTypo = (compareWord = "", againstWord = "") => {
		const isException = (x) => typoExceptions.includes(x);
		if (isException(compareWord) || isException(againstWord)) return false;

		const conditions = [isTypoCondition1, isTypoCondition2, isTypoCondition3];
		const fitsConditions = conditions.some((func) =>
			func(compareWord, againstWord)
		);
		const isKeyword = searchKeywords.includes(compareWord);
		return fitsConditions && !isKeyword;
	};

	// Public
	const correct = (searchTerms = "") => {
		consell.log(`Correcting ${searchTerms}...`, CChannel.custom("search"));
		if (!searchTerms) return "";

		const words = searchTerms.split(" ").map((originalWord) => {
			const compareWord = originalWord.lower().replace(/[^a-z]+/g, "");
			if (compareWord.length <= 3) return originalWord;

			const correctWord = searchKeywords.find((keyword) =>
				isTypo(compareWord, keyword)
			);
			return correctWord || originalWord;
		});

		const rebuiltTerms = words.join(" ");
		return rebuiltTerms;
	};

	return {
		isTypo,
		correct,
		keywords,
		conditions: [isTypoCondition1, isTypoCondition2, isTypoCondition3],
	};
})();
